export default "__VITE_ASSET__x32YKZ42__"